module.exports = __webpack_public_path__ + "media/images/category-health-aa4bad75a6c7746adfd75d262bd1244a.jpg";